module.exports = "/images/flash-flood@3x.png?32e16079840d61959e05913bff1b0dae";